import { extend } from 'lodash'
import tinycolor from 'tinycolor2'

export function getReadableTextColor(hex = '#FFFFFF', colorScheme = defaultColorScheme()) {
  return tinycolor(hex).isLight() ? colorScheme.darkText : colorScheme.lightText
}

export function getSlightlyContrastingColor(hex = '#FFFFFF') {
  const tinyColor = tinycolor(hex)
  return tinyColor.isLight() ? tinyColor.darken(10).toHexString() : tinyColor.lighten(10).toHexString()
}

export function stringifyColors(colorScheme) {
  const { primary, secondary, tertiary, highlight } = colorScheme
  return `${primary},${secondary},${tertiary},${highlight}`
}

export function parseColorScheme(string) {
  const colors = string.split(',')
  return extend({}, defaultColorScheme(), {
    primary: colors[0],
    secondary: colors[1],
    tertiary: colors[2],
    highlight: colors[3],
  })
}

export function defaultColorScheme() {
  return {
    primary: '#F3F3F3',
    secondary: '#FFFFFF',
    tertiary: '#808080',
    highlight: '#5A00FF',

    // Note: these are not user customizable
    darkText: '#3f3f42',
    lightText: '#FFFFFF',
  }
}
